import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Container from "@mui/material/Container/Container";
import Grid from "@mui/material/Grid/Grid";
import Button from "@mui/material/Button/Button";
import Stack from "@mui/material/Stack/Stack";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import ProjectListItem from "../../components/project-list-item";
import ProjectGridItem from "../../components/project-grid-item";
import moment from 'moment';
import firebase from "../../firebase/firebase";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import Typography from "@mui/material/Typography/Typography";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import {useNavigate } from 'react-router-dom'
import {AuthUserContext} from "../../providers/AuthProvider";
import SearchIcon from '@mui/icons-material/Search';
import GridViewSharpIcon from "@mui/icons-material/GridViewSharp";
import ReorderSharpIcon from "@mui/icons-material/ReorderSharp";
import ArtistGridItem from "../../components/artist-grid-item";
import ArtistListItemNew from "../../components/ArtistListItem";
import ScrollToTop from "../../utils/scrollTop";

function CrDashboard() {
  const navigator = useNavigate();
  const { user, profile} = React.useContext(AuthUserContext);
  const [searchArtist , setSearchArtist] = React.useState('')
  const [searchProject , setSearchProject] = React.useState('')
  const [view, setView] = React.useState('Grid')
  const [artistView, setArtistView] = React.useState('Grid')
  const [list, setList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [openProfileDialog, setOpenProfileDialog] = React.useState(false);
  const [services, setServices] = React.useState([])
  const [filterData, setFilterData] = React.useState([])

  const search = (param , state) => {
     
    if (state === '') {
      setFilterData([...param])
    } else {
      const regex = new RegExp(state);
      setFilterData(param.filter((u) => regex?.test(u.title) || regex?.test(u.creatorName) ));
    }
  }
  
  React.useEffect(() => {
    const serviceRef = firebase.firestore().collection('services').orderBy('createdAt', "desc")
    serviceRef.get()
      .then((snapshot) => {
        if (snapshot.size > 0){
          const list = []
          snapshot.docs.forEach((d) => {
            list.push({id: d.id, ...d.data()});
          })
          debugger

          setServices(list);
        }
      })
  }, [])
  React.useEffect(() => {
    const projectRef = firebase.firestore().collection('projects').orderBy('createdAt', "desc")
      .where('uid',  '==', profile?.uid)
      .where('draft', '==', false);
    try {
      projectRef.get().then(async (projectsList) => {
        const profileRef = firebase.firestore().collection('users').doc(profile.id);
         
        const profileSnapshot = await profileRef.get();
         
        if (profileSnapshot && !profileSnapshot.data().workHistory) {
          setOpenProfileDialog(true)
        }
        const projects = []
        if(projectsList && projectsList.docs.length > 0) {
          projectsList.docs.forEach(d => projects.push({id: d.id, ...d.data()}))
        }
        setList(projects);
        setLoading(false)
      })
    } catch (e) {
      setLoading(false)
    }
  }, []);

  const filteredArtist = searchArtist === "" ? services : services.filter((item) => {return (item.name.toLowerCase()).startsWith(searchArtist.toLowerCase())})
  const filteredProjects = searchProject === "" ? list : list.filter((item) => {return (item.title.toLowerCase()).startsWith(searchProject.toLowerCase())})
  // console.log(searchProject)

  return (
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}

      <Container maxWidth="lg" sx={{ my:  5}}>
        <Stack direction={'row'} spacing={5} justifyContent="start"
               alignItems="start">
          <div style={{flex: 1}}/>

          <div style={{display : "flex" , flexDirection : "row" , justifyContent : "space-between"}}>

          <Stack direction='row'  justifyContent="center" sx={{mt:-1.25}}                             alignItems="center">
              <TextField value={searchProject}
               onChange={(e) => setSearchProject(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    search(list , searchProject)
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
              
              {/* <Autocomplete spacing={2} sx={{ width: 300 }}
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={ ["all" , ...list.map((option) => option.title)]}
              value = {searchProject}
              onChange={(e , newValue) => { setSearchProject(newValue)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=  {<SearchIcon />}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}/>
                  )}
              /> */}
              
            
            {/* <small>View:</small> */}
            {''}
            <IconButton size={'small'} color={'primary'} sx={{mt:-2,
              opacity: view === 'Grid'? 1 : .5
            }} onClick={() => setView('Grid')}>
              <GridViewSharpIcon />
            </IconButton>
            {/* | */}
            <IconButton size={'small'} color={'primary'}  sx={{mt:-2,
              opacity: view == 'List'? 1 : .5
            }} onClick={() => setView('List')}>
              <ReorderSharpIcon />
            </IconButton>
            {''}
          </div>

        </Stack>

      </Container>

      {loading ?  <Container maxWidth="lg" sx={{ pb:5}}>
        <CircularProgress />
      </Container>:      
       <Container maxWidth="lg" sx={{textAlign: 'left', pb:5}}>
        <Typography  color={'primary'} sx={{mb:5, mt: -11,fontSize:"38px"}}>
        My projects
        
        {list && list.length === 0 ? <>
        <br></br>
        <br></br>
        <Typography variant="h6" sx={{textAlign:"center"}}>You haven't posted  any project yet. </Typography> </> : <></>}

        </Typography>
        <Grid container spacing={3} alignItems="start" sx={{mb:5}}>
          {list && list.length > 0 && filteredProjects.map((d) => {

            return view === 'List' ?<ProjectListItem
              image={d.mediaFiles.image}
              key={d.id}
              id={d.id}
              title={d.title}
              genre={d.genre}
              posted={moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
              director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}
            />: <ProjectGridItem
              image={d.mediaFiles.image}
              key={d.id}
              id={d.id}
              title={d.title}
              genre={d.genre}
              posted={moment(d.createdAt.seconds * 1000).format('MMM DD, YYYY')}
              director={d?.directors && d?.directors?.length > 0 ? d?.directors[0].director :'Robert Eggers'}

            />
          })
          }
          {/*
          repeat project
          */}
        </Grid>
        <br></br>     <br></br>     <br></br>
        {/*{services.length}*/}
        <Typography  color={'primary'} sx={{mb: "-4%",fontSize:"38px" }}>
          Artists that may interest you
        </Typography>
            <div style={{float : "right" , display : "flex", flexDirection : "row" , justifyContent : "space-between"}}>

            <Stack direction='row'  justifyContent="center"
                   alignItems="center">
              <TextField value={searchArtist}
               onChange={(e) => setSearchArtist(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    search(services , setSearchArtist)
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
            {/* <Autocomplete spacing={2} sx={{ width: 300 }}
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={ ["all" , ...services.map((option) => option.name)]}
              value = {searchArtist}
              onChange={(e , newValue) => { setSearchArtist(newValue)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=  {<SearchIcon />}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}/>
                  )}

              /> */}
              {/* <small>View:</small> */}
              {''}
              <IconButton size={'small'} color={'primary'} sx={{
                opacity: artistView === 'Grid'? 1 : .5
              }} onClick={() => setArtistView('Grid')}>
                <GridViewSharpIcon />
              </IconButton>
              {/* | */}
              <IconButton size={'small'} color={'primary'}  sx={{
                opacity: artistView == 'List'? 1 : .5
              }} onClick={() => setArtistView('List')}>
                <ReorderSharpIcon />
              </IconButton>
              {''}
            </div>
        <Grid container spacing={3} alignItems="start" sx={{mb:5}}>
          {services.length > 0 && filteredArtist.map((service) => {
            return artistView === 'Grid'  ?
            <ArtistGridItem
              title={service.name}
              posted={moment(service.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
              location={service.location}
              genre={service.skills}
              image={service.avatar}
              id={service.id}
            /> : <ArtistListItemNew
              title={service.name}
              posted={moment(service.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
              location={service.location}
              genre={service.skills}
              image={service.avatar}
              id={service.id}/>
          })
          }

        </Grid>
      </Container>
    }
      <Dialog
        open={openProfileDialog}
        onClose={() => setOpenProfileDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='lg'
      >
        <DialogTitle id="alert-dialog-title" >
          <Stack direction={'row'} spacing={2}>
            <Typography variant={'h6'} sx={{flex:1}}>You are almost there...</Typography>
            <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpenProfileDialog(false)}>
              <CloseIcon/>
            </IconButton>
          </Stack>


        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" >
            <Typography variant={'body2'}> Would you like to finish setting up your profile before browsing through projects?</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{paddingX: 3, paddingY: 2}}>
          <Button onClick={() => setOpenProfileDialog(false)} size={'small'} sx={{color: '#000',paddingX: 3}}>Not now</Button>
          <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={() => {
            setOpenProfileDialog(false);
            navigator('/creator/profile')
          }}>
            Setup profile
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
export default CrDashboard;